import React from 'react';
import { Accordion, AccordionItem } from './Accordion';
import { CtaButton } from './CtaButton';
const modules: AccordionItem[] = [{
  title: '🧮 Calculadora de Costo Material + Costo x Hora',
  content: 'Cargás tus materiales, alquiler, sueldos y horas de sillón, y la planilla te devuelve el costo real de cada tratamiento y cuánto vale una hora de tu trabajo. Dejás de cobrar a ojo y empezás a poner precios con margen.'
}, {
  title: '📊 Presupuesto Dinámico',
  content: 'Elegís los tratamientos de una lista y el presupuesto se arma solo, con honorarios, materiales, totales y resumen gráfico. Listo para imprimir o enviar por WhatsApp en menos de 5 minutos.'
}, {
  title: '📦 Control de Stock',
  content: 'Planilla con stock actual, stock mínimo y alerta automática de reposición por producto. Nunca más te quedás sin composite, anestesia o guantes en medio de la semana.'
}, {
  title: '🔍 Comparador de Proveedores',
  content: 'Cargás precio unitario, condiciones de pago y tiempo de entrega de cada proveedor y la planilla te marca la opción más conveniente. Ahorro directo en cada compra de insumos.'
}, {
  title: '📅 Sistema de Turnos',
  content: 'Agenda semanal por franja horaria con paciente, tratamiento y estado del turno. Ves los huecos libres de un vistazo y reducís ausencias y superposiciones.'
}];
export function Modules() {
  return <section className="px-5 py-10" data-id="element-133" data-mp="3f2w8pdd5laah">
      <h2 className="text-center text-2xl font-black leading-snug text-white" data-id="element-134" data-mp="3ab4rvujsuixj">
        Para eso fabricamos este Kit de herramientas
      </h2>
      <p className="mt-2 text-center text-sm text-teal-100/70" data-id="element-135" data-mp="36a2rvbi262ui">
        Tocá cada módulo para ver qué resuelve
      </p>

      <div className="mt-6" data-id="element-136" data-mp="31c16ul12ntge">
        <Accordion items={modules} data-id="element-137" data-mp="2wb3oa7c5gxed" />
      </div>

      <CtaButton className="mt-7" data-id="element-138" data-mp="2w9senqw0wvfc" />
    </section>;
}